import ApiHandler from './ApiHandler';

export default {
    getUploadUrl: data => ApiHandler.post(`/uploader/get-upload-url`, data),
    abortUpload: data => ApiHandler.post(`/uploader/abort-upload`, data)
};
